import { useSearchParams } from 'react-router-dom';

import { CERTIFICATE_TASKS_TABLE_PAGE_SIZE } from '../shared/constants/tasks.constant';
import { parseString } from '../shared/helpers/url-parameter-parser';
import { GetCertificateTasksParams } from './api/certificates';

const DEFAULT_SORT = 'received-desc';

type CertificateTasksTableQueryState = {
  skip: number;
  size: number;
  sort: string | undefined;
  filters: Partial<GetCertificateTasksParams>;
  setParams: (params: Record<string, string | number | string[] | undefined>) => void;
};

export const useCertificateTasksTableQueryParams = (): CertificateTasksTableQueryState => {
  const [sp, setSp] = useSearchParams();

  const skip =
    (Number(sp.get('page') ?? 1) - 1) * Number(sp.get('size') ?? CERTIFICATE_TASKS_TABLE_PAGE_SIZE);
  const size = Number(sp.get('size') ?? CERTIFICATE_TASKS_TABLE_PAGE_SIZE);

  const sort = sp.get('sort') ?? DEFAULT_SORT;

  const filters: Partial<GetCertificateTasksParams> = {
    search: parseString(sp.get('search')),
  };

  const setParams = (params: Record<string, string | number | string[] | undefined>): void => {
    const next = new URLSearchParams(sp);

    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || (Array.isArray(value) && value.length === 0) || value === '') {
        next.delete(key);

        return;
      }

      if (Array.isArray(value)) {
        next.set(key, value.join(','));

        return;
      }

      next.set(key, String(value));
    });

    setSp(next, { replace: true });
  };

  return {
    skip,
    size,
    sort,
    filters,
    setParams,
  };
};
